export enum ETaskStatus {
  WAITING = '258f9429-1b7b-48bd-b5c9-a6da2a76beac',
  DONE = 'f30f673d-2a05-4a1b-b02b-84a1005bb1a6',
}
